<div class="acc-content">
  <div id="dateTimeSelection" *ngIf="sections.dateTimeSelection">
    <div class="row mtp10">
      <div class="col-100 mdcol-100 xscol-100">
        <div id="preferredDealerSection" class="mbt10" *ngIf="preferedDealer">
          <div class="cst-input-field xsmbt5">
            <label translate>lblPreferredDealer </label>
          </div>
          <div class="boxheight">
            <div class="boxst1">
              <div class="row">
                <div class="col-50 xscol-100 smcol-100 xsmbt10 smmbt10">
                  <h4 class="title-h2 mbt10 xsmbt0 mdmbt5 smmbt5 text-primary dflex">
                    {{preferedDealer.dealerName}}<span *ngIf="preferedDealer.distance !== 0"> -
                      {{preferedDealer.distance | number:'2.2-2'}} km away</span>
                  </h4>
                  <div class="dflex font18">
                    <div>
                      <p class="">{{preferedDealer.address}}</p>
                      <p class="">{{preferedDealer.city}} <span *ngIf="preferedDealer.state">,
                          {{preferedDealer.state}}</span></p>
                      <p class="">{{preferedDealer.country}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-50 xscol-100 smcol-100 text-right smtext-left">
                  <h4 class="title-h4 mbt10 xsmbt0 mdmbt20 smmbt20 text-primary">

                    <a translate class="popup-open xsmbt0 link" data-popup="popup-selecteddealermap"
                      *ngIf="preferedDealer.distance !== 0" (click)="showMap()">
                      <u translate><em class="fas fa-map-marker-alt mrt5"></em>lblShowInmap</u>
                    </a>
                  </h4>

                  <div class="">

                    <div>
                      <div class="timeinfo xsmtp20" *ngIf="preferedDealer.occasionWiseOpeningHoursList.length > 0">
                        <table class="">
                          <ng-container *ngFor="let element of preferedDealer.occasionWiseOpeningHoursList">
                            <tr *ngIf="element.isOpen">
                              <td class="pr10">
                                <span *ngFor="let day of element.day; let i = index">
                                  <span *ngIf="i !== 0">, </span>
                                  {{day | slice:0:3}}</span>
                              </td>
                              <th scope="col"><strong>{{element.openingHours}}</strong></th>
                            </tr>
                          </ng-container>
                          <tr>
                            <td class="pr10">
                              <span translate>lblNextAvailable</span>
                            </td>
                            <th scope="col"><strong id="nextavailabledate">
                                {{defaultNextAvailableDate | date:'shortDate'}}
                              </strong></th>
                          </tr>
                        </table>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </div>



              <div class="flmid mtp20" style="border-top: 1px solid #ccc; padding-top: 15px;">
                <div style="width: 100%;">
                  <p translate class="font18 clrred" id="someServiceNotAvailableSection"
                    *ngIf="preferedDealer.notAvailableServices && preferedDealer.notAvailableServices.length > 0">
                    <span translate>lblThe </span> <strong>{{preferedDealer.notAvailableServices}}</strong>
                    lblFacilityIsUnavailableWithThisDealer
                  </p>
                  <p translate class="font18 mtp5 clrred" id="pickupDroOffNotAvailableSection"
                    *ngIf="customerPickupDropOffServiceSelection && !preferedDealer.isVehiclePickUpAndDropOffService">
                    lblThisDealerNotCarriesOutPickUpAndDropffService
                  </p>
                </div>
                <div class="minw300 text-right smtext-left xsmtp10" style="width: 100%;">
                  <button translate data-popup="popup-selectdealer" aria-label="Center Align"
                    class="btn btn-primary" value="Next" (click)="openDealerPopup()">
                    <em class="fas fa-map-marked-alt mrt5"></em>lblChooseAnotherDealerLocation
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
 
      <div style="width: 100%;">
        <div *ngIf="rentalService">
          <div class="col-100 mtp20" [ngClass]="!timeSlotSection ? 'enableContent' :'disable' ">
            <div class="boxst1">
              <div>
                <label translate class="cst-checkbox font18 mb-0">
                  <input type="checkbox" id="needRentalCar" [(ngModel)]="isNeedRentalCar"
                    (change)="getDealerRentalCars()" />
                  <span></span>
                  <!-- lblWantCarHire -->
                  lblDoYouWishToAvailRentedCar
                </label>
              </div>

              <!-- HRENTAL -->
              <div class=" xsmtp20 mtp20" *ngIf="!timeSlotSection && isNeedRentalCar && !isGenericRentalCar"
                id="rentalCarSection">
                <div class="cst-input-field">
                  <label translate>lblSelectCarHire</label>
                </div>
                <div class="cmn-tbl rental-car-tbl">
                  <table>
                    <tbody>
                      <tr class="pos-sticky">
                        <th id="name">&nbsp;</th>
                        <th id="brand" translate>lblBrand</th>
                        <th id="model" translate>lblModel</th>
                        <th id="price" translate class="txtright">lblPrice</th>
                      </tr>
                      <tr *ngFor="let rentalCar of rentalCarAvailabilities">
                        <td>
                          <label class="cst-radio only-input">
                            <input name="rentalcar" type="radio" (change)="onChangeRentalCar()"
                            [(ngModel)]="selectedRentalCarIndex" [value]="rentalCar.vehicleId" />
                            <span></span>
                          </label>
                        </td>
                        <td>{{rentalCar.makeName}}</td>
                        <td>{{rentalCar.model}}</td>
                        <td class="txtright">{{rentalCar.price|number:'1.2-2'}}</td>
                      </tr>
                      <tr *ngIf="rentalCarAvailabilities.length === 0">
                        <td colspan="4">
                          <strong translate>lblNoCarAvailableForRent</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class=" xsmtp20 mtp20" *ngIf="!timeSlotSection && isNeedRentalCar && isGenericRentalCar"
                id="genericRentalCarSection">
                <div class="cst-input-field">
                  <label translate>lblSelectCarHire</label>
                </div>
                <div class="cmn-tbl rental-car-tbl">
                  <table>
                    <tbody>
                      <tr class="pos-sticky">
                        <th id="name">&nbsp;</th>
                        <th id="brand" translate>lblType</th>
                        <th id="price" translate class="txtright">lblPrice</th>
                      </tr>
                      <tr *ngFor="let rentalCar of genericRentalCarList; let i = index">
                        <td>
                          <label class="cst-radio only-input">
                            <input name="rentalcar" type="radio" (change)="onChangeGenericRentalCar()"
                              [(ngModel)]="selectedGenericRentalCarIndex" [value]="rentalCar.typeId" />
                            <span></span>
                          </label>
                        </td>
                        <td>{{rentalCar.type}}</td>
                        <td class="txtright">{{rentalCar.price}}</td>
                      </tr>
                      <tr *ngIf="genericRentalCarList.length === 0">
                        <td colspan="3">
                          <strong translate>lblNoCarAvailableForRent</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-100 mdcol-100 xscol-100">
          <div class="mtp20">
            <div class="dflex mobileorder cst-input-field">

              <label translate class="mrt10 order1">lblSelectAnAvailableDate</label>


              <div class="ml-auto order0">
                <label class="nowrap"><span translate>lblEstimatedRepairTimeIs</span> <strong class="mlt10">
                  {{ formatedTotalServiceTimeDate | date:'HH:mm'}}
                    <span translate>lblHours</span></strong></label>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-5 mb-b20">
                <div class="cst-picker" id="bookingCalendarId" #rentalCarBookingCalendar>
                  <input type="text" id="bookingCalender" appAfDatepicker [dateTime]="false" [isInline]="true"
                    [startDate]="NextAvailDate" [value]="selectedDate" [isOnlyTime]="false"
                    [defaultDate]="selectedDate ? selectedDate : dealerNextAvailDate"
                    [disabledDates]="disableDatesOfCalender" [endDate]="endDate" (OnSelect)="changeDate($event)"
                    (OnChangeMonthYear)="onChangeMonthYear($event)" (OnGenerate)="onChangeInCalender($event)" />
                </div>
                <div class="Legends-border mtp10">
                  <div class="calendar-legends">
                    <strong class="color-bg Legends" style="background-color:#8c8c8d"></strong>
                    <span translate class="flex-center calendar-legend-text">lblDealerNotAvailble</span>
                  </div>
                  <div class="calendar-legends">
                    <strong class="color-bg Legends" style="background-color:#fff"></strong> <span translate
                      class="flex-center calendar-legend-text">
                      lblAvailableDatesForDealers</span>
                  </div>
                </div>
                <div class="Legends-border mtp10" *ngIf="rentalService && showLegends">

                  <div class="calendar-legends">
                    <strong class="color-bg Legends" style="background-color:#b8fdc0"></strong>
                    <span translate
                      class="flex-center calendar-legend-text">lblAvailableDatesForDealerWithRentalCars</span>
                  </div>
                  <div class="calendar-legends">
                    <strong class="color-bg Legends" style="background-color:#fff"></strong> <span translate
                      class="flex-center calendar-legend-text">
                      lblAvailableDatesForDealerWithoutRentalCars</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 ml-auto">
                <div class="p-2 boxst1">
                  <h4 class="title-h4 mb-2" translate>lblChooseTime</h4>
                  <p><strong>{{displaySelectedDate | date:'shortDate'}}</strong></p>
                  <ng-container *ngIf="mechanicSlots && mechanicSlots.length > 0; else load_else_template">
                    <div class="ctm-btn-group mt-2" role="group" ngbRadioGroup name="radioBasic">
                      <div *ngFor="let slot of mechanicSlots;let i=index">
                        <label ngbButtonLabel class="btn-outline-primary label-check" for="slot{{i}}" [ngClass]="isSlotSelected(slot) ? 'selectedSlotClass' : ''">
                          <input ngbButton type="radio" class="btn-check" id="slot{{i}}" (click)="SelectSlots(slot)"
                            [value]="slot">{{slot.startTimeLocal | date:'HH:mm'}}
                        </label>
                      </div>
                    </div>
                   </ng-container>
                  <ng-template #load_else_template>
                    <h4 class="title-h4 mb-2 clrred" translate>lblNoSlotAvailable</h4>
                  </ng-template>
                </div>



              </div>

              <div class="col-100">
                <div class="chk-grp Legends-border p-15">
                  <div class="mbt10 smmbt10 flmid" *ngIf="isPickUpDropOff &&  preferedDealer?.isVehiclePickUpAndDropOffService" [ngClass]="!timeSlotSection ? 'enableContent' :'disable' ">
                    <label translate class="cst-checkbox">
                      <input type="checkbox" id="customerPickupDropupService"
                        [(ngModel)]="customerPickupDropOffServiceSelection"
                        (change)="onChangeCustomerPickupDropupServiceCheckbox()" />
                      <span> </span>
                      lblIwantCarPickupAndDropUpService
                    </label>

                    <!-- enable when pick up and drop off service selected -->
                    <div id="PickUpDropOffTimeSection" class="xsmtp10 xsmbt20"
                      [ngClass]="customerPickupDropOffServiceSelection ? 'enableContent' :'disable' ">
                      <div class="cst-input-field flmid mt10">
                        <label class="duration nowrap pr-10"><span translate>lblPickUpTime</span> <strong
                            class="required">
                            * </strong></label>
                        <input type="number" class="duration-hr form-control" placeholder="HH" [(ngModel)]="pickUpHours"
                          maxlength="2" (keyup)="MoveToDurationMinute($event)" min="0" max="23"
                          onkeydown="if(event.key==='.'){event.preventDefault();}"
                          oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                        <span class="py-1"> : </span>
                        <input type="number" class="duration-min form-control" (keyup)="CheckMinute($event)"
                          [(ngModel)]="pickUpMinutes" min="0" max="59" #pickUpminuteInput placeholder="MM"
                          onkeydown="if(event.key==='.'){event.preventDefault();}"
                          oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                      </div>
                    </div>
                  </div>

                  <div class="mbt10 smmbt10 flmid custom-revert"
                    *ngIf="preferedDealer"
                    [ngClass]="!customerPickupDropOffServiceSelection ? 'enableContent' :'disable' ">
                    <div>
                      <label translate class="cst-checkbox flex0 mb-0">
                        <input type="checkbox" id="customerWaiting" [(ngModel)]="timeSlotSection"
                          (change)="onChangeCustomerWaitingCheckbox()" />
                        <span> </span>
                        lblIwantToWaitWhileTheCarIsBeingRepaired:
                      </label>
                    </div>

                    <div translate class="font12 xsmtp10 xsmlt30 xsmtp0 smmbt10 mlt10 nowrap truncate"
                      [ngbTooltip]="message">
                      lbl(ThisMayAffectAvailableDays)
                    </div>
                  </div>


                  <div id="morefollowSection" class="mtp20">
                    <div [ngClass]="!customerPickupDropOffServiceSelection ? 'enableContent' :'disable' " *ngIf="onlineCheckinFacility">
                      <div class="row mbt10 xsmbt10">
                        <div class="col-100">
                          <div class="gryborderbottom"></div>
                        </div>
                      </div>
                      <div class="cst-input-field mbt10 xsmbt10">
                        <label translate>lblWillYouLikeToAvailOnlineCheck-In facility?</label>
                      </div>
                      <div class="mbt5 mbt10 row xsmbt10">
                        <div class="xsmbt5 smmbt0 col-50 xscol-100 smcol-100 smmbt10">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="onlinecheckin" [(ngModel)]="availCheckInFacility"
                              [value]="true" />
                            <span class="mrt10"></span>
                            <p translate>lblYes</p>
                          </label>
                        </div>
                        <div class="col-50 xscol-100 smcol-100">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="onlinecheckin" [(ngModel)]="availCheckInFacility"
                              [value]="false" />
                            <span class="mrt10"></span>
                            <p translate>lblNot</p>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="isShareBoxEnable"
                      [ngClass]="!timeSlotSection  && !customerPickupDropOffServiceSelection ? 'enableContent' :'disable' ">
                      <div class="row mbt10 xsmbt10">
                        <div class="col-100">
                          <div class="gryborderbottom"></div>
                        </div>
                      </div>
                      <div class="cst-input-field mbt10 xsmbt10">
                        <label translate>lblWhenWillYouDeliverTheCar?</label>
                      </div>
                      <div class="mbt5 mbt10 row xsmbt10">
                        <div class="xsmbt5 smmbt0 col-50 xscol-100 smcol-100 smmbt10">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="delivercar" [(ngModel)]="deliverCarWithinBusinessHours"
                              [value]="true" />
                            <span class="mrt10"></span>
                            <p><span translate>lblWithinBusinessHour</span> {{businesshours}}</p>
                          </label>
                        </div>
                        <div class="col-50 xscol-100 smcol-100">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="delivercar" [(ngModel)]="deliverCarWithinBusinessHours"
                              [value]="false" />
                            <span class="mrt10"></span>
                            <p translate>lblOutsideOpeningHours-useShareBox</p>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="isShareBoxEnable"
                      [ngClass]="!timeSlotSection  && !customerPickupDropOffServiceSelection ? 'enableContent' :'disable' ">
                      <div class="row xsmbt10">
                        <div class="col-100">
                          <div class="gryborderbottom"></div>
                        </div>
                      </div>
                      <div class="cst-input-field mtp10 mbt10 xsmbt10">
                        <label translate>lblWhenWillYouPickUpTheCar?</label>
                      </div>
                      <div class="row xsmbt15">
                        <div class="xsmbt5 col-50 xscol-100 smcol-100 smmbt10">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="pickupcar" [(ngModel)]="pickupCarWithinBusinessHours"
                              [value]="true" />
                            <span class="mrt10"></span>
                            <p><span translate>lblWithinBusinessHour</span> {{businesshours}}</p>
                          </label>
                        </div>
                        <div class="col-50 xscol-100 smcol-100">
                          <label class="cst-radio flexbox">
                            <input type="radio" name="pickupcar" [(ngModel)]="pickupCarWithinBusinessHours"
                              [value]="false" />
                            <span class="mrt10"></span>
                            <p translate>lblOutsideOpeningHours-useShareBox</p>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="clearfix mtp15 xsmtp15">
            <div class="flex-center space-between fright">
              <div class="flex-grow cst-validation stepTwoValidation mrt20" *ngIf="rentalCarValidationMessage">
                <span translate>lblSelectedRentalCarIsNotAvailableOn </span>
                {{ displaySelectedDate | date:'shortDate'}}
                <span translate>lblPleaseChooseADifferentDate.</span>
              </div>
              <div translate class="flex-grow cst-validation stepThreeValidation mrt20" *ngIf="!selectedDate">
                lblPleaseSelectADate
              </div>
              <div translate class="flex-grow cst-validation stepThreeValidation mrt20"
                *ngIf="isRentalCarSelectedError">
                lblPleaseSelectRentalCar
              </div>
              <div translate class="flex-grow cst-validation stepThreeValidation mrt20"
                *ngIf="customerPickupDropOffServiceSelection && !preferedDealer.isVehiclePickUpAndDropOffService">
                lblThisDealerNotCarriesOutPickUpAndDropffService
              </div>
              <div translate class="flex-grow cst-validation stepThreeValidation mrt20"
                *ngIf="customerPickupDropOffServiceSelection && preferedDealer.isVehiclePickUpAndDropOffService && !pickUpHours">
                lblPickUpTimeRequired
              </div>
              <div class="btn-grp fright xsmbt10 flex-center xsmtp0 xsflexend">
                <button translate class="btn btn-primary" aria-label="Center Align"
                  [ngClass]="{'disable': disableNextButton || !selectedSlot || isRentalCarSelectedError}" id="showStep4" value="Next" (click)="onSelectDateNext()">
                  lblNext <em class="pos-relative fa fa-angle-right ml-2"></em>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

  <div class="row" id="finalSummarySection" *ngIf="sections.finalSummarySection">
    <div class="col-100">
      <div id="allSummarySection" class="xsmtp0 font18">
        <div class="boxst2 mbt25 xsmbt10 smmbt10">
          <div class="row">
            <div class="col-100 ">
              <h4 class="title-h4 mbt10 xsmbt5 text-primary">
                {{preferedDealer.dealerName}} <span *ngIf="preferedDealer.distance !== 0"> -
                  {{preferedDealer.distance | number:'2.2-2'}}km Away</span>
              </h4>
              <div>
                <p class="">{{preferedDealer.address}}</p>
                <p class="">{{preferedDealer.city}} <span *ngIf="preferedDealer.state">,
                    {{preferedDealer.state}}</span>, <span class="">{{preferedDealer.country}}</span>
                </p>

              </div>
            </div>

            <div class="col-50 xscol-100">

              <h4 translate class="title-h4 text-primary mbt10 mtp30 smmtp10 smmbt0 mdmtp15">
                lblRequestedRepairDetails
              </h4>

              <div class="tableborder0" *ngIf="!timeSlotSection">


                <div class="info">
                  <div class="lefttitle">
                    <span translate class="">lblRequestedDate</span> :
                  </div>

                  <p>
                    {{ AppointmentDatetime | date:'short'}}
                  </p>

                </div>
                <div class="info">
                  <div class="lefttitle">
                    <span translate>lblYourChoices</span> :
                  </div>

                  <ul>
                    <li *ngIf="deliverCarWithinBusinessHours != undefined"><span class="">
                        <span class="break-all" translate
                          *ngIf="deliverCarWithinBusinessHours">lblDeliverInRegularOpeningHours</span>
                        <span class="break-all" translate
                          *ngIf="!deliverCarWithinBusinessHours && !isShareBoxEnable">lblDeliverUsingKeyDrop</span>
                        <span class="break-all" translate
                          *ngIf="!deliverCarWithinBusinessHours && isShareBoxEnable">lblDeliverUsingShareBox</span>
                      </span></li>
                    <li *ngIf="pickupCarWithinBusinessHours != undefined"><span class="">
                        <span class="break-all" translate
                          *ngIf="pickupCarWithinBusinessHours">lblPickupInRegularOpeningHours</span>
                        <span class="break-all" translate
                          *ngIf="!pickupCarWithinBusinessHours && !isShareBoxEnable">lblPickupUsingKeyDrop</span>
                        <span class="break-all" translate
                          *ngIf="!pickupCarWithinBusinessHours && isShareBoxEnable">lblPickupUsingShareBox</span>
                      </span></li>

                    <li *ngIf="availCheckInFacility==='true'">
                      <span class="" translate>
                        lblOnlineCheckInFacilty
                      </span>
                    </li>
                    <li *ngIf="customerPickupDropOffServiceSelection"><span class="">
                        <span class="break-all" translate>lblPickUpTime</span>
                        <span>: {{ PickupDatetime | date:'short' }}</span>
                      </span></li>
                    <li *ngIf="isNeedRentalCar && selectedRentalCarIndex > -1">
                      <span class="">{{ selectedRentalCarIndex
                        > -1 ? 'Want car hire' : ''}}
                      </span>
                    </li>
                  </ul>

                </div>
              </div>

              <div class="" *ngIf="timeSlotSection">
                <div class="info">
                  <div class="lefttitle"><span translate class="">lblRequestedDate</span>:</div>
                  <p><span class="">
                      {{ displaySelectedDate | date:'shortDate'}}
                    </span>
                  </p>
                </div>
                <div class="info">
                  <div class="lefttitle">
                    <span translate>lblYourChoices</span> :
                  </div>
                  <ul>
                    <li><span class="">
                        <span class="break-all" translate>lblWaitWhileTheCarIsBeingRepaired</span>
                      </span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-50 xscol-100">
              <h4 translate class="title-h4 text-primary mbt10 mtp30 smmtp10 smmbt0 mdmtp15 xsmtp10 xsmbt10">
                lblServices
              </h4>
              <p *ngFor="let service of selectedService">
                <em class="fas fa-check text-green mrt10"></em> {{service.name}}
                <span *ngIf="service.isDisplayPriceForDealer"><strong class="text-green"> -
                    {{ service.priceIncVat | number:'1.2-2'}}
                  </strong>
                </span>
                <span class="d-block pl-4" *ngIf="service.isAdditionalCustomerComment && service.additionalCustomerComment">
                  <em class="fa fa-angle-right"></em><span class="bold" translate>lblAdditionalComment</span> : {{service.additionalCustomerComment}}
                </span>
              </p>
              <p *ngIf="stonchip?.length"><em class="fas fa-check text-green mrt10"></em> {{stonchip}}</p>
            </div>
          </div>
        </div>

        <div class="mbt30 xsmbt15 cst-input-field">
          <label translate class="mbt10 dis-blk">
            lblIsThereAnythingElseYouWouldLikeUs
          </label>
          <div class="cst-input-field">
            <input type="text" class="input-big" [(ngModel)]="additionalComments" (keyup.enter)="completeSelectWorkshop()" />
          </div>
        </div>
        <div class="cst-button-grp">
          <div class="cst-button-grp clearfix mbt20 fright">
            <button type="button" class="btn btn-secondary fleft mrt10" id="showDateTimeSelection" translate
              (click)="goToDateTimeSection()">
              <em class="pos-relative fa fa-angle-left mr-2"></em> lblChangeDate
            </button>
            <button type="button" class="btn btn-primary" id="showAdditonalServiceSection" translate
              (click)="completeSelectWorkshop()">
              lblConfirmDate <em class="pos-relative fa fa-angle-right ml-2"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>